import React from "react";

import { CustomTag } from "@app/analytics/components/Tag";

const TopicRowTags = () => {
  return (
    <>
      <CustomTag
        autoGenerated
        backgroundColor="avatar.indigo.dark"
        color="#FFF"
      >
        Readout
      </CustomTag>
    </>
  );
};

export default TopicRowTags;
